<script>
    import { get } from 'dot-prop'

    export let context
    export let formKeypath // the full form keypath e.g. "games.3.attributes.videos.2.url"
    export let helptext

    const levels = ['warn', 'error']

    $: validation = get(context, `error.${formKeypath}`) || {}
    $: show = levels.includes(validation.level)
</script>

{#if show}
    <small class="form-text text-{validation.level}"> {validation.message || helptext} </small>
{:else if helptext}<small class="form-text text-muted">{helptext}</small>{/if}
